import { createContext, useContext, useState, useCallback } from 'react';

interface ServiceContextValue {
  service: string;
  setService: (service: string) => void;
}

/** @graph-connects none */
const noop = () => {
  // デフォルト値のプレースホルダー
};

/**
 * @graph-stack ux-mirror
 * @graph-domain UX
 * @graph-business サービス選択状態を画面横断で共有するReactコンテキストを定義する
 * @graph-connects /api/ux-mirror [calls] /Api/Ux Mirrorを呼び出す
 */
export const ServiceContext = createContext<ServiceContextValue>({
  service: '',
  setService: noop,
});

/**
 * サービス選択の状態管理フック
 * '' = 全サービス（フィルタなし）
 * @graph-stack ux-mirror
 * @graph-domain UX
 * @graph-business 選択サービスをローカル保存しつつ状態管理するフックを提供する
 * @graph-connects /api/ux-mirror [calls] /Api/Ux Mirrorを呼び出す
 */
export function useServiceState() {
  const [service, setServiceRaw] = useState<string>(
    () => localStorage.getItem('ux-mirror:service') ?? '',
  );

  const setService = useCallback((s: string) => {
    setServiceRaw(s);
    localStorage.setItem('ux-mirror:service', s);
  }, []);

  return { service, setService };
}

/**
 * コンポーネントから現在のサービスを取得するフック
 * @graph-stack ux-mirror
 * @graph-domain UX
 * @graph-business コンポーネントから現在の選択サービスを取得するフックを提供する
 * @graph-connects /api/ux-mirror [calls] /Api/Ux Mirrorを呼び出す
 */
export function useService(): ServiceContextValue {
  return useContext(ServiceContext);
}
